// extracted by mini-css-extract-plugin
module.exports = {"container":"_b595f47","close":"_36da1a0","resolverLink":"_0e4a9de"};